(function () {
  'use strict';

  // ── DETECT iOS ────────────────────────────────────────────
  var isIOS = (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );

  // ── CORE UNLOCK FUNCTION ──────────────────────────────────
  // Removes any CSS or inline style that could block scroll
  // on <html> or <body> — runs aggressively and repeatedly.
  function unlockScroll() {
    var html = document.documentElement;
    var body = document.body;

    if (!body) return; // too early, will retry

    // Force scroll-enabling styles on both html and body
    var targets = [html, body];
    targets.forEach(function (el) {
      el.style.setProperty('overflow',   'visible', 'important');
      el.style.setProperty('overflow-y', 'auto',    'important');
      el.style.setProperty('overflow-x', 'hidden',  'important');
      el.style.setProperty('height',     'auto',    'important');
      el.style.setProperty('position',   'static',  'important');
      el.style.setProperty('touch-action','pan-y',  'important');
      el.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    });

    // Remove any scroll-locking CSS classes commonly used by themes
    var lockClasses = [
      'scroll-lock', 'scrollLock', 'scroll-locked',
      'overflow-hidden', 'no-scroll', 'noscroll',
      'is-locked', 'is-fixed', 'menu-open',
      'modal-open', 'drawer-open', 'js-loading'
    ];
    lockClasses.forEach(function (cls) {
      html.classList.remove(cls);
      body.classList.remove(cls);
    });
  }

  // ── STYLE INJECTION ───────────────────────────────────────
  // CSS-level override — wins against any theme stylesheet
  // using !important on scroll-blocking rules.
  function injectUnlockStyles() {
    var style = document.createElement('style');
    style.id  = 'ios-scroll-fix';
    style.textContent = [
      /* Force scroll on root elements at all times */
      'html, body {',
      '  overflow-x: hidden !important;',
      '  overflow-y: auto !important;',
      '  height: auto !important;',
      '  position: static !important;',
      '  touch-action: pan-y !important;',
      '  -webkit-overflow-scrolling: touch !important;',
      '}',

      /* Neutralise scroll-lock classes while js-loading is active */
      'html.js-loading body,',
      'body.scroll-lock,',
      'body.no-scroll,',
      'body.overflow-hidden,',
      'html.scroll-lock body,',
      'html.no-scroll body,',
      'html.overflow-hidden body {',
      '  overflow-y: auto !important;',
      '  position: static !important;',
      '  touch-action: pan-y !important;',
      '}',

      /* Prevent fixed-position overlays from blocking touch events */
      /* (only targets elements explicitly set to block interaction) */
      '[data-scroll-lock] {',
      '  touch-action: pan-y !important;',
      '  pointer-events: none !important;',
      '}',
    ].join('\n');

    // Insert as very first child of <head> so it has highest source order
    var head = document.head || document.getElementsByTagName('head')[0];
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  }

  // ── PASSIVE TOUCH LISTENER ────────────────────────────────
  // Ensures the document-level touchstart never blocks scroll.
  // iOS requires { passive: true } — without it Safari waits
  // for the handler to return before allowing scroll.
  function addPassiveTouchListener() {
    document.addEventListener('touchstart', function () {}, { passive: true });
    document.addEventListener('touchmove',  function () {}, { passive: true });
  }

  // ── BFCACHE FIX ───────────────────────────────────────────
  // iOS Safari restores pages from bfcache on back/forward.
  // DOMContentLoaded and load never re-fire — so js-loading
  // gets stuck. pageshow always fires, even on cache restore.
  function addBfcacheFix() {
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        // Page restored from bfcache — force full unlock
        unlockScroll();
        document.documentElement.classList.remove('js-loading');
        document.documentElement.classList.add('js-loaded');
      }
    });
  }

  // ── MUTATION OBSERVER GUARD ───────────────────────────────
  // Watches for anything re-applying scroll lock AFTER unlock.
  // If a theme script adds overflow:hidden back, we remove it.
  function watchForScrollLock() {
    if (!window.MutationObserver) return;

    var lockClasses = [
      'scroll-lock','scrollLock','scroll-locked',
      'overflow-hidden','no-scroll','noscroll',
      'is-locked','is-fixed','menu-open',
      'modal-open','drawer-open'
    ];

    var guardian = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var el = m.target;
        // Only care about html and body
        if (el !== document.documentElement && el !== document.body) return;

        var relock = false;

        // Check if a lock class was added
        if (m.type === 'attributes' && m.attributeName === 'class') {
          lockClasses.forEach(function (cls) {
            if (el.classList.contains(cls)) relock = true;
          });
        }

        // Check if inline style set overflow:hidden
        if (m.type === 'attributes' && m.attributeName === 'style') {
          var ov = el.style.overflow || el.style.overflowY;
          if (ov === 'hidden') relock = true;
        }

        if (relock) {
          // Small delay so the theme's own handler finishes first,
          // then we override without breaking UI completely
          setTimeout(unlockScroll, 50);
        }
      });
    });

    guardian.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
    guardian.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  // ── TIMED UNLOCK SWEEP ────────────────────────────────────
  // Belt-and-suspenders: run unlockScroll at key moments
  // in case any of the event-based fixes miss a window.
  function scheduleUnlockSweep() {
    // Immediately
    unlockScroll();
    // After typical DOMContentLoaded window
    setTimeout(unlockScroll, 300);
    setTimeout(unlockScroll, 800);
    setTimeout(unlockScroll, 1500);
    // After worst-case load event on slow iOS
    setTimeout(unlockScroll, 5000);

    document.addEventListener('DOMContentLoaded', unlockScroll);
    window.addEventListener('load', unlockScroll);
  }

  // ── BOOT ─────────────────────────────────────────────────
  // Always inject styles (CSS wins against theme stylesheets)
  injectUnlockStyles();

  // iOS-only runtime fixes
  if (isIOS) {
    addPassiveTouchListener();
    addBfcacheFix();
    scheduleUnlockSweep();

    // Wait for body to exist before setting up the observer
    if (document.body) {
      watchForScrollLock();
    } else {
      document.addEventListener('DOMContentLoaded', watchForScrollLock);
    }
  }

})();